const faqItems = [
    {
        question: "Why do you define youth as ages 11-30?",
        answer: "Our age range reflects our commitment to supporting young people through all stages of their journey toward independence, particularly during challenging domestic situations. Traditional support systems often diminish after young people leave the school system, creating a critical gap in resources precisely when many need them most.\n\n" +
                    "The current economic climate means many young adults live at home longer, and during this extended transition, those navigating complex family dynamics, personal identity, or differences in beliefs need continuous support. By extending our services through age 30, we ensure comprehensive support for all young people seeking to build safe, independent lives aligned with their authentic selves.\n\n" +
                    "Our age range acknowledges that everyone's path to independence is different, and we're here to provide support and resources for whatever steps come next on that journey."
    },
    {
        question: "What does all-inclusive mean?",
        answer: "All-inclusive means that we are open to all. We do not discriminate or judge. We welcome everyone."
    },
    {
        question: "Is this a faith-based organization?",
        answer: "Short answer, no. We are not a faith-based organization. We are a church, but we do not discriminate or judge, especially based on faith. We do not require any faith to be a part of our mission nor will we push our faith on you. Everyone is welcome, even those without faith. We do have religious services, but they are optional and not required to be a part of our community or our mission."
    },
    {
        question: "Why don't you have pictures on your website?",
        answer: "Privacy is important to us. We want to make sure that everyone feels safe and comfortable. We do not want to post pictures of our members without their consent. We also want to make sure that we are not posting pictures of people who may have been or are currently at risk."
    },
    {
        question: "What kind of events do you host?",
        answer: "We host a variety of events including community service projects, social gatherings, and educational workshops. Our events are designed to be inclusive and welcoming to all."
    },
    {
        question: "Do you have any membership fees?",
        answer: "No, we do not have any membership fees. Our organization is free to join and participate in."
    },
    {
        question: "Is a hotdog a sandwich?",
        answer: "No. It is a taco."
    },
    {
        question: "Your website has an interesting color scheme. Does it have any meaning? What inspired it?",
        answer: "We've actually gotten this question a few times and it has an interesting answer. If you're in light mode, the color scheme you're seeing is called Cosmic Latte. It's the average color of the universe. We've also found that it helps some people with dyslexia read the text easier. If you're in dark mode then it's just multiple shades of navy blue and cobalt, which is just the website designer's favorite color."
    },
    {
        question: "How can I get involved?",
        answer: "You can get involved by attending our events, volunteering, or donating. We are always looking for new members and volunteers to help us with our mission."
    },
    {
        question: "How can I donate?",
        answer: "You can donate by visiting our website and clicking on the donate button."
    },
    {
        question: "How can I volunteer?",
        answer: "You can volunteer by attending our events and helping out. You can find volunteer opportunities by emailing us or calling us, and we will put you on our list."
    },
    {
        question: "What does COTAD stand for?",
        answer: "COTAD has multiple interpretations that have evolved with our community. Visit our dedicated page to explore the different meanings and choose the one that resonates with you most.",
        link: "/cotad"
    }
];

export default faqItems;